import React from "react";

import { Button, ButtonProps } from "@mui/material";
import { Link, LinkProps } from "react-router-dom";

export type ButtonLinkProps = ButtonProps & LinkProps;

export const ButtonLink = ({ children, ...props }: ButtonLinkProps) => (
  <Button component={Link} {...props}>
    {children}
  </Button>
);
